import { useFormControlGroup } from '../../../hooks/use-form-control-group';
import { FormSentimentType } from '../types';

export const useSentimentMessage = (
  type: FormSentimentType,
  isShowAlways: boolean
) => {
  const { contextData } = useFormControlGroup();
  const { state } = contextData;

  return {
    isVisible: isShowAlways || (type == 'error' && state == 'error'),
  };
};
